// productService.js
export async function getProductList() {
    const response = await fetch(`${process.env.REACT_APP_HOST}/products`);
    
    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }
    const data = await response.json();
    console.log('data');
    return data;
}

export async function getProduct(id) {
    const response = await fetch(`${process.env.REACT_APP_HOST}/products/${id}`);
    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }
    const data = await response.json();
    return data;
}

export async function getFeaturedList() {
    const response = await fetch(`${process.env.REACT_APP_HOST}/api/featured-products`);
    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }
    const data = await response.json();
    return data;
}

export async function searchProducts(searchTerm) {
    const response = await fetch(`${process.env.REACT_APP_HOST}/products/search?name=${searchTerm}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Error: ${response.statusText} (status: ${response.status})`);
    }

    const data = await response.json();
    return data;
}

